// Comentários do presell
(function () {
  'use strict';

  // Ao clicar para curtir algum comentário
  $('.presell-comments-list').on('click', '.presell-comment-like', function (ev) {
    ev.preventDefault();
    $(this).toggleClass('active');
  });

  // Ao clicar para responder algum comentário
  $('.presell-comments-list').on('click', '.presell-comment-reply', function (ev) {
    ev.preventDefault();
    smoothScroll('#presell-comments-form');
  });

  // Ao enviar o formulário do comentário
  $('#presell-comments-form').on('submit', function (ev) {
    ev.preventDefault();
    showLoader();
    setTimeout(() => {
      hideLoader();
      showAlert(
        'Comentário enviado',
        'Seu comentário foi enviado e será publicado após ser aprovado pela moderação.',
        'success',
      );
      $('#presell-comments-form').find('input, textarea').val('');
    }, 1500);
  });
})();
